 /*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(document).ready( function() {
  $(function() {
    $("#pickup-date").datepicker( {
      minDate: 0,
      beforeShowDay: function(day) {
            var day = day.getDay();
            if (day == 0 || day == 1) {
                return [false]
            } else {
                return [true]
            }
         },
      onClose: function(dateText) {
        if (dateText !== '') {
          let selectedDate = new Date(dateText);
          if (selectedDate.getDay() > 1 && selectedDate.getDay() < 6) {
            $("#pickup-time").data('TimePicker').options.minTime = '10:30am';
            $("#pickup-time").data('TimePicker').options.startTime = '10:30am';
            $("#pickup-time").data('TimePicker').options.maxTime = '5:30pm';
            $("#pickup-time").data('TimePicker').items = null;
            $("#pickup-time").data('TimePicker').widget.instance = null;
            $("#pickup-time").val('');
          }
          else {
            $("#pickup-time").data('TimePicker').options.minTime = '9:00am';
            $("#pickup-time").data('TimePicker').options.startTime = '9:00am';
            $("#pickup-time").data('TimePicker').options.maxTime = '5:00pm';
            $("#pickup-time").data('TimePicker').items = null;
            $("#pickup-time").data('TimePicker').widget.instance = null;
            $("#pickup-time").val('');
          }
        }
      }
    } );
    $("#pickup-time").timepicker( {
    timeFormat: 'h:mm p',
    interval: 30,
    minTime: '9:00am',
    maxTime: '5:00pm',
    defaultTime: '11:00am',
    startTime: '9:00am',
    dynamic: false,
    dropdown: true,
    scrollbar: true
    } );
  });
});